import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { HiOutlineChevronDoubleUp } from 'react-icons/hi';

function ScrollToTop({
  el,
  displayThreshold,
  icon,
  containerClassName,
  ...rest
}) {
  const element = el || window;
  const [showElement, setShowElement] = React.useState(false);

  const handleScroll = React.useCallback(() => {
    if (element.scrollTop > displayThreshold) setShowElement(true);
    else setShowElement(false);
  }, [element, displayThreshold]);

  const handleClick = () => {
    element.scrollTo({ top: 0, behavior: 'smooth' });
  };

  React.useEffect(() => {
    element.addEventListener('scroll', handleScroll);
    return () => element.removeEventListener('scroll', handleScroll);
  }, [element, handleScroll]);

  if (!showElement) return null;

  return (
    <div
      role="presentation"
      {...rest}
      onClick={handleClick}
      className={cn(
        'z-10 absolute bottom-16 right-6 cursor-pointer bg-primary-500 rounded text-white flex p-2',
        containerClassName
      )}
    >
      {icon}
    </div>
  );
}

ScrollToTop.defaultProps = {
  el: '',
  icon: <HiOutlineChevronDoubleUp className="h-5 w-5" />,
  displayThreshold: 100,
  containerClassName: '',
};

ScrollToTop.propTypes = {
  icon: PropTypes.element,
  displayThreshold: PropTypes.number,
  containerClassName: PropTypes.string,
  el: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),
};

export default ScrollToTop;
